/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type SearchContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormTemplateContainer_viewer$ref: FragmentReference;
export type FormTemplateContainer_viewer = {|
  +id: string,
  +first_name: ?string,
  +last_name: ?string,
  +primary_brand: ?{|
    +id: string
  |},
  +$fragmentRefs: SearchContainer_viewer$ref,
  +$refType: FormTemplateContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "FormTemplateContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "first_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "last_name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "primary_brand",
      "storageKey": null,
      "args": null,
      "concreteType": "Brand",
      "plural": false,
      "selections": [
        v0
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SearchContainer_viewer",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '5ad46512837b2facc09f66550a632e01';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Form/__generated__/FormTemplateContainer_viewer.graphql.js